import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("DurationTerminal", "NumberCompareTerminal", {
    text: function() {
      return (
        [
          this.get('terminal'),
          this.get('relop'),
          this._valueDisplay()
        ].join(" ")
      );
    },

    type: function() {
      return 'Duration';
    },

    minutesFromValue: function() {
      return Math.floor(this.get('value') / 60);
    },

    secondsFromValue: function() {
      return this.get('value') - (this.minutesFromValue() * 60);
    },

    _valueDisplay: function() {
      return (
        this.minutesFromValue() + " min" + (this.secondsFromValue() ? " " + this.secondsFromValue() + " sec" : "")
      );
    }
  });
});
